import React from "react";
import { MDBRow, MDBCol } from "mdb-react-ui-kit";
import poshmarkLogo from "../../assets/marketplaces/poshmark.svg";

const PoshmarkDetails = ({
  formData,
  poshmarkConnected,
  poshmarkSubCategories,
  handlePoshmarkCategoryChange,
  handleInputChange,
  handleVariantChange,
}) => {
  return (
    <div
      className="poshmark-details-section mt-5 p-4"
      style={{
        border: "1px solid #ddd",
        borderRadius: "12px",
        background: "#f9f9f9",
      }}
    >
      <h4
        className="mb-3"
        style={{
          color: "#764ba2",
          display: "flex",
          alignItems: "center",
        }}
      >
        <img
          src={poshmarkLogo}
          alt="Poshmark"
          style={{ width: "28px", marginRight: "10px" }}
        />
        Poshmark Listing Details
      </h4>
      <MDBRow>
        <MDBCol md="6">
          <div className="form-group mb-3">
            <label
              style={{
                fontWeight: "600",
                display: "block",
                marginBottom: "6px",
              }}
            >
              Main Category *
            </label>
            <select
              className="form-select"
              value={formData.poshmarkCategory || "Women"}
              onChange={(e) => handlePoshmarkCategoryChange(e.target.value)}
              style={{
                padding: "10px",
                borderRadius: "8px",
                border: "2px solid #ddd",
                width: "100%",
              }}
            >
              <option value="">Select Category</option>
              <option value="Women">Women</option>
              <option value="Men">Men</option>
              <option value="Kids">Kids</option>
              <option value="Home">Home</option>
              <option value="Pets">Pets</option>
              <option value="Electronics">Electronics</option>
            </select>
          </div>
        </MDBCol>
        <MDBCol md="6">
          <div className="form-group mb-3">
            <label
              style={{
                fontWeight: "600",
                display: "block",
                marginBottom: "6px",
              }}
            >
              Sub Category *
            </label>
            <select
              className="form-select"
              value={formData.poshmarkSubCategory || ""}
              onChange={(e) =>
                handleInputChange("poshmarkSubCategory", e.target.value)
              }
              style={{
                padding: "10px",
                borderRadius: "8px",
                border: "2px solid #ddd",
                width: "100%",
              }}
              disabled={!formData.poshmarkCategory}
            >
              <option value="">Select Subcategory</option>
              {poshmarkSubCategories.map((sub) => (
                <option key={sub} value={sub}>
                  {sub}
                </option>
              ))}
            </select>
          </div>
        </MDBCol>
        <MDBCol md="4">
          <div className="form-group mb-3">
            <label
              style={{
                fontWeight: "600",
                display: "block",
                marginBottom: "6px",
              }}
            >
              Size Type
            </label>
            <select
              className="form-select"
              value={formData.poshmarkSizeType || "standard"}
              onChange={(e) =>
                handleInputChange("poshmarkSizeType", e.target.value)
              }
              style={{
                padding: "10px",
                borderRadius: "8px",
                border: "2px solid #ddd",
                width: "100%",
              }}
            >
              <option value="standard">Standard</option>
              <option value="custom">Custom</option>
            </select>
          </div>
        </MDBCol>
        <MDBCol md="4">
          <div className="form-group mb-3">
            <label
              style={{
                fontWeight: "600",
                display: "block",
                marginBottom: "6px",
              }}
            >
              Size Value
            </label>
            <input
              type="text"
              className="form-control"
              value={formData.variants?.[0]?.size || "OS"}
              onChange={(e) => {
                if (formData.variants.length > 0) {
                  handleVariantChange(
                    formData.variants[0].id,
                    "size",
                    e.target.value,
                  );
                }
              }}
              style={{
                padding: "10px",
                borderRadius: "8px",
                border: "2px solid #ddd",
                width: "100%",
              }}
              placeholder="OS or 10"
            />
          </div>
        </MDBCol>
        <MDBCol md="4">
          <div className="form-group mb-3">
            <label
              style={{
                fontWeight: "600",
                display: "block",
                marginBottom: "6px",
              }}
            >
              Original Price (Optional)
            </label>
            <input
              type="number"
              className="form-control"
              value={formData.pricerange?.split(" - ")[1] || ""}
              onChange={(e) => {
                const low =
                  formData.pricerange?.split(" - ")[0] || formData.price;
                handleInputChange("pricerange", `${low} - ${e.target.value}`);
              }}
              style={{
                padding: "10px",
                borderRadius: "8px",
                border: "2px solid #ddd",
                width: "100%",
              }}
              placeholder="Enter original price"
            />
          </div>
        </MDBCol>
        <MDBCol md="4">
          <div className="form-group mb-3">
            <label
              style={{
                fontWeight: "600",
                display: "block",
                marginBottom: "6px",
              }}
            >
              Availability
            </label>
            <select
              className="form-select"
              value={formData.poshmarkAvailability || "available"}
              onChange={(e) =>
                handleInputChange("poshmarkAvailability", e.target.value)
              }
              style={{
                padding: "10px",
                borderRadius: "8px",
                border: "2px solid #ddd",
                width: "100%",
              }}
            >
              <option value="available">For Sale</option>
              <option value="not_for_sale">Not For Sale</option>
              <option value="coming_soon">Drops</option>
            </select>
          </div>
        </MDBCol>
        <MDBCol md="4">
          <div className="form-group mb-3">
            <label
              style={{
                fontWeight: "600",
                display: "block",
                marginBottom: "6px",
              }}
            >
              Color
            </label>
            <select
              className="form-select"
              value={formData.color || ""}
              onChange={(e) => handleInputChange("color", e.target.value)}
              style={{
                padding: "10px",
                borderRadius: "8px",
                border: "2px solid #ddd",
                width: "100%",
              }}
            >
              <option value="">Select Color</option>
              <option>Red</option>
              <option>Blue</option>
              <option>Black</option>
              <option>White</option>
              <option>Green</option>
              <option>Beige</option>
              <option>Brown</option>
              <option>Gray</option>
              <option>Pink</option>
              <option>Purple</option>
            </select>
          </div>
        </MDBCol>
      </MDBRow>
      <div
        className="mt-3 p-3"
        style={{
          borderRadius: "8px",
          backgroundColor: poshmarkConnected ? "#d4edda" : "#fff3cd",
          color: poshmarkConnected ? "#155724" : "#856404",
          border: `1px solid ${poshmarkConnected ? "#c3e6cb" : "#ffeeba"}`,
        }}
      >
        <strong>Poshmark Extension Status:</strong>{" "}
        {poshmarkConnected
          ? "Connected - Ready to list!"
          : "Not connected - Click 'Integrate' button above"}
      </div>
    </div>
  );
};

export default PoshmarkDetails;

